import React from "react";
import useTicketsReportData from "./useTicketsReportData";
import { Table } from "antd";
import { FSelect } from "../../commons/formFields/FSelect";
import SuperAdminContainer from "../SuperAdminContainer";
import { ScreenHeader } from "../../../CommonComponents";

const SuperAdminMissingTransactions = () => {
  const {
    onClubChange,
    clubsAndLeaguesData,
    clubsAndLeaguesLoading,
    columns,
    selectedClub,
    allMissingTransactions,
  } = useTicketsReportData();

  return (
    <SuperAdminContainer>
      <ScreenHeader
        title="Missing Transactions"
        elementCount={allMissingTransactions?.[selectedClub]?.length || 0}
      />
      <div
        style={{
          marginTop: "2px",
          backgroundColor: "var(--primary-white-background)",
          padding: "8px 12px",
        }}
      >
        <FSelect
          value={selectedClub}
          onChange={onClubChange}
          dataList={clubsAndLeaguesData?.allClubs || []}
          dataKey="id"
          dataValue="label"
          style={{
            backgroundColor: "transparent",
            border: "0px none transparent",
            color: "white",
            borderRadius: 0,
            fontSize: 16,
            width: "200px",
          }}
          name="status"
          display="my-row"
          placeholder="Club"
          tabIndex="2"
        />
      </div>
      <Table
        columns={columns}
        bordered
        dataSource={allMissingTransactions?.[selectedClub] || []}
        loading={clubsAndLeaguesLoading}
        bodyStyle={{
          backgroundColor: "#ffffff",
        }}
        scroll={{ x: true }}
      />
    </SuperAdminContainer>
  );
};

export default SuperAdminMissingTransactions;
